import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useChatInputStore, useModalStore, useAuthStore } from '@/store';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';
import Tooltip from '@/components/Tooltip';

export default function NewChatBotPicker({ selectedBot, isWorkMode = false }) {
  const { colors } = useTheme();
  const openModal = useModalStore(state => state.actions.openModal);
  const label = selectedBot ? `Change bot, currently ${selectedBot.name}` : isWorkMode ? 'Choose a bot' : 'Chat with a bot';

  const selectBot = (bot) => {
    if (bot?.flags?.isPlusOnly && !useAuthStore.getState().user?.flags?.isPlus) {
      openModal('PricingModal', { title: 'Chat with this bot', subtitle: 'This bot requires a Plus subscription.' });
      return false;
    }
    // Select in place: keep the draft, attachments, model and Chat/Work mode.
    const composer = useChatInputStore.getState();
    composer.setContext('new');
    composer.setSelectedAgents(bot ? [bot.id] : [], { botId: bot?.id || null });
    return true;
  };

  return (
    <Tooltip label={label}>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={label}
        accessibilityHint="Choose, change, or clear a bot and manage your default bot."
        aria-haspopup="dialog"
        hitSlop={{ top: 5, bottom: 5, left: 3, right: 3 }}
        onPress={() => openModal('BotPickerModal', { onSelect: selectBot, isWorkMode })}
        style={({ hovered, pressed }) => [styles.button, (selectedBot || hovered || pressed) && { backgroundColor: colors.solid_color_tertiary }]}
      >
        <Icon name="robot" size={18} solid={!!selectedBot} color={colors.text_color_primary} />
      </Pressable>
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  button: { width: 34, height: 34, borderRadius: 17, flexShrink: 0, alignItems: 'center', justifyContent: 'center' },
});
